@if (showUpdateBanner$ | async) {
<div
  class="pwa-update-banner bg-primary-500 fixed top-0 left-0 right-0 z-50 bg-primary text-white shadow-lg animate-slide-down"
>
  <div class="flex items-center justify-between p-4 gap-4 max-w-full">
    <div class="flex items-center gap-3 flex-1">
      <svg
        class="w-5 h-5 flex-shrink-0 text-surface-100"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
        ></path>
      </svg>
      <div>
        <h3 class="font-semibold text-base">
          {{ 'shared.pwa.update.title' | translate }}
        </h3>
        <p class="text-surface-100 text-sm">
          {{ 'shared.pwa.update.description' | translate }}
        </p>
      </div>
    </div>
    <div class="flex gap-2 flex-shrink-0">
      <button
        (click)="dismiss()"
        class="px-3 py-2 text-surface-100 text-sm font-medium rounded-lg hover: transition-colors"
      >
        {{ 'shared.pwa.update.later' | translate }}
      </button>
      <button
        (click)="update()"
        class="px-4 py-2 bg-surface-900 text-surface-100 text-sm font-semibold rounded-lg hover: transition-colors"
      >
        {{ 'shared.pwa.update.update' | translate }}
      </button>
    </div>
  </div>
</div>
}
